function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M467.8,103H398v43.7h64.3c3,0,5.5,2.5,5.5,5.5v309.6c0,3-2.5,5.5-5.5,5.5H152.7c-3,0-5.5-2.5-5.5-5.5V309.5h-43.7v157.8 c0,24.1,19.6,43.7,43.7,43.7h320.6c24.1,0,43.7-19.6,43.7-43.7V146.7C511.5,122.6,491.9,103,467.8,103z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M150.7,244.2l-28.7-8.3c-3-0.8-4.7-4-3.9-7L182.3,7.6c0.8-3,4-4.7,7-3.9l28.7,8.3c3,0.8,4.7,4,3.9,7l-64.2,221.3 C156.8,243.4,153.7,245.1,150.7,244.2z M77.6,191.4l20.5-21.8c2.2-2.3,2-6-0.4-8.1L55.1,124l42.6-37.5c2.4-2.1,2.6-5.8,0.4-8.1 L77.6,56.5c-2.1-2.3-5.7-2.4-8-0.2L1.8,119.8c-2.4,2.2-2.4,6,0,8.2l67.8,63.6C71.9,193.8,75.5,193.7,77.6,191.4L77.6,191.4z  M270.4,191.7l67.8-63.6c2.4-2.2,2.4-6,0-8.2l-67.8-63.6c-2.3-2.1-5.8-2-8,0.2l-20.5,21.8c-2.2,2.3-2,6,0.4,8.1l42.6,37.6 l-42.6,37.5c-2.4,2.1-2.6,5.8-0.4,8.1l20.5,21.8C264.5,193.7,268.1,193.8,270.4,191.7L270.4,191.7z"
});

function SvgCodeBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeBlock);
export default __webpack_public_path__ + "static/media/codeBlock.d2491096.svg";
export { ForwardRef as ReactComponent };